import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Transfer from "@/pages/Transfer";
import Deposit from "@/pages/Deposit";
import Withdraw from "@/pages/Withdraw";
import SalesLinks from "@/pages/SalesLinks";
import SalesLinkEditor from "@/pages/SalesLinkEditor";
import Affiliate from "@/pages/Affiliate";
import OAuthCallback from "@/pages/OAuthCallback";
import Clientes from "@/pages/Clientes";
import MyMembers from "@/pages/MyMembers";
import MuralEditor from "@/pages/MuralEditor";
import WhatsApp from "@/pages/WhatsApp";
import Telegram from "@/pages/Telegram";
import Smtp from "@/pages/Smtp";
import Leads from "@/pages/Leads";
import ApiKeys from "@/pages/ApiKeys";
import Admin from "@/pages/Admin";
import AdminWithdraws from "@/pages/AdminWithdraws";
import AdminUsers from "@/pages/AdminUsers";
import AdminResetBalances from "@/pages/AdminResetBalances";
import AdminFees from "@/pages/AdminFees";
import PersonalLink from "@/pages/PersonalLink";
import PublicFunnel from "@/pages/PublicFunnel";
import VideoSalesPage from "@/pages/VideoSalesPage";
import VideoPageEditor from "@/pages/VideoPageEditor";
import MemberLogin from "@/pages/MemberLogin";
import MemberArea from "@/pages/MemberArea";
import Settings from "@/pages/Settings";
import Taxas from "@/pages/Taxas";
import AppShell from "@/components/AppShell";
import PlanGate from "@/components/PlanGate";
import ChatWidget from "@/components/ChatWidget";
import { FeaturesProvider } from "@/hooks/useFeatures";
import { getUser } from "@/lib/api";

const Protected = ({ children }) => {
  const u = getUser();
  if (!u) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
};

const AdminOnly = ({ children }) => {
  const u = getUser();
  if (!u) return <Navigate to="/login" replace />;
  if (u.role !== "admin") return <Navigate to="/app" replace />;
  return <AppShell>{children}</AppShell>;
};

export default function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-right" richColors />
      <FeaturesProvider>
        <PlanGate />
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/taxas" element={<Taxas />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/f/:slug" element={<PublicFunnel />} />
          <Route path="/v/:slug" element={<VideoSalesPage />} />
          <Route path="/oauth/mercadopago/callback" element={<OAuthCallback />} />
          <Route path="/member/login" element={<MemberLogin />} />
          <Route path="/member" element={<MemberArea />} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/transfer" element={<Protected><Transfer /></Protected>} />
          <Route path="/app/deposit" element={<Protected><Deposit /></Protected>} />
          <Route path="/app/withdraw" element={<Protected><Withdraw /></Protected>} />
          <Route path="/app/funnels" element={<Protected><SalesLinks /></Protected>} />
          <Route path="/app/funnels/new" element={<Protected><SalesLinkEditor /></Protected>} />
          <Route path="/app/funnels/:id/edit" element={<Protected><SalesLinkEditor /></Protected>} />
          <Route path="/app/video-pages/new" element={<Protected><VideoPageEditor /></Protected>} />
          <Route path="/app/video-pages/:id/edit" element={<Protected><VideoPageEditor /></Protected>} />
          <Route path="/app/affiliate" element={<Protected><Affiliate /></Protected>} />
          <Route path="/app/clientes" element={<Protected><Clientes /></Protected>} />
          <Route path="/app/meus-membros" element={<Protected><MyMembers /></Protected>} />
          <Route path="/app/mural" element={<Protected><MuralEditor scope="mine" /></Protected>} />
          <Route path="/app/admin/mural-global" element={<AdminOnly><MuralEditor scope="global" /></AdminOnly>} />
          <Route path="/app/whatsapp" element={<Protected><WhatsApp /></Protected>} />
          <Route path="/app/telegram" element={<Protected><Telegram /></Protected>} />
          <Route path="/app/smtp" element={<Protected><Smtp /></Protected>} />
          <Route path="/app/leads" element={<Protected><Leads /></Protected>} />
          <Route path="/app/api" element={<AdminOnly><ApiKeys /></AdminOnly>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/app/admin" element={<AdminOnly><Admin /></AdminOnly>} />
          <Route path="/app/admin/withdraws" element={<AdminOnly><AdminWithdraws /></AdminOnly>} />
          <Route path="/app/admin/users" element={<AdminOnly><AdminUsers /></AdminOnly>} />
          <Route path="/app/admin/reset-balances" element={<AdminOnly><AdminResetBalances /></AdminOnly>} />
          <Route path="/app/admin/fees" element={<AdminOnly><AdminFees /></AdminOnly>} />
          {/* Personal short links — catch-all no formato /nome/cpf3 (sempre por último!) */}
          <Route path="/:name/:suffix" element={<PersonalLink />} />
        </Routes>
      </BrowserRouter>
      </FeaturesProvider>
    </div>
  );
}
